
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class YeniAbonelikBasvuruAPI extends BaseAPI {


  constructor () {
    const baseUrl = environment.API_URL + "YeniAbonelikSave";
    super(baseUrl);
  }


  saveYeniAbonelikBasvuruSave(request: YeniAbonelikSaveRequest){

    return this.post("", request, false);

  }

}
export default new YeniAbonelikBasvuruAPI();

class YeniAbonelikSaveRequest {
  sicilKodu: number;
  basvuruTuruId: number;
  bolgeKodu: number;
  mahalleKodu: number;
  caddeSokakKodu: number;
  kapiNo: number;
  altKapiNo?: string;
  daireNo?: number;
  altDaireNo?: string;
  blokNo?: string;
  katNo?: string;
  siteApartmanAdi?: string;
  pafta?: string;
  ada?: number;
  parsel?: number;
  aboneTipiKodu ? : number;
  sayacTuruKodu ?: number;
  damgaYili?: number;
  sayacMarkaKodu?: number;
  sayacSeriNo?: string;
  akilliSayacModeli?: number;
  sayacYeri?: number | null;
  kullanimSekliKodu?: number;
  kriterKodu?: number;
  metrekare?: number;
  ogrenciSayisi?: number;
  koltukSayisi?: number;
  personelSayisi?: number;
  yatakSayisi?: number;
  daskPoliceNo?: number;
  daskPoliceBaslangicTarihi?: Date;
  daskPoliceBitisTarihi?: Date;
  aciklama?: string;
  captchaToken?: string;

  constructor(
    sicilKodu: number,
    basvuruTuruId: number,
    bolgeKodu: number,
    mahalleKodu: number,
    caddeSokakKodu: number,
    kapiNo: number,
    aboneTipiKodu?: number,
    sayacTuruKodu?: number,
    kullanimSekliKodu?: number,
    ada?: number,
    parsel?: number,
    altKapiNo?: string,
    daireNo?: number,
    altDaireNo?: string,
    blokNo?: string,
    katNo?: string,
    siteApartmanAdi?: string,
    pafta?: string,
    damgaYili?: number,
    sayacMarkaKodu?: number,
    sayacSeriNo?: string,
    akilliSayacModeli?: number,
    sayacYeri?: number | null,
    kriterKodu?: number,
    metrekare?: number,
    ogrenciSayisi?: number,
    koltukSayisi?: number,
    personelSayisi?: number,
    yatakSayisi?: number,
    daskPoliceNo?: number,
    daskPoliceBaslangicTarihi?: Date,
    daskPoliceBitisTarihi?: Date,
    aciklama?: string,
    captchaToken?: string

  ) {
    this.sicilKodu = sicilKodu;
    this.basvuruTuruId = basvuruTuruId;
    this.bolgeKodu = bolgeKodu;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.kapiNo = kapiNo;
    this.aboneTipiKodu = aboneTipiKodu;
    this.sayacTuruKodu = sayacTuruKodu;
    this.kullanimSekliKodu = kullanimSekliKodu;
    this.ada = ada;
    this.parsel = parsel;
    this.altKapiNo = altKapiNo;
    this.daireNo = daireNo;
    this.altDaireNo = altDaireNo;
    this.blokNo = blokNo;
    this.katNo = katNo;
    this.siteApartmanAdi = siteApartmanAdi;
    this.pafta = pafta;
    this.damgaYili = damgaYili;
    this.sayacMarkaKodu = sayacMarkaKodu;
    this.sayacSeriNo = sayacSeriNo;
    this.akilliSayacModeli = akilliSayacModeli;
    this.sayacYeri = sayacYeri;
    this.kriterKodu = kriterKodu;
    this.metrekare = metrekare;
    this.ogrenciSayisi = ogrenciSayisi;
    this.koltukSayisi = koltukSayisi;
    this.personelSayisi = personelSayisi;
    this.yatakSayisi = yatakSayisi;
    this.daskPoliceNo = daskPoliceNo;
    this.daskPoliceBaslangicTarihi = daskPoliceBaslangicTarihi;
    this.daskPoliceBitisTarihi = daskPoliceBitisTarihi;
    this.aciklama = aciklama;
    this.captchaToken = captchaToken;
  }
}
export  {YeniAbonelikSaveRequest};